import { CONTENT_SPACE_CLASSNAME } from '@/constants';
import styles from './Develop.module.scss';

export default function Develop() {
  return (
    <main className={styles.main}>
      <div className={CONTENT_SPACE_CLASSNAME}></div>
    </main>
  );
}
